import React from "react";
import QuotationListPresenter from "./QuotationList.presenter";
import { bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";
import { MapStateToProps, MapDispatchToProps, C_Props, MergedProps, C_States } from "./QuotationList.type";
import {
  RootState, TCb, AppNotifications, QuotationOutputModel, QuotationStatus,
  QuotationExportExcelOutputModel, QuotationOptionService
} from "../../../../models";
import { NotificationActions } from "../../../../store/actions";
import _ from "lodash";
import { APP_ROUTES, INITIAL_FETCHING_PAGINATION_DATA } from "../../../../constants";
import { QuotationService } from "../../../../services";
import { loadCallback } from "../../../../utils";
import { withRouter } from "react-router-dom";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import moment from "moment";

const EMPTY_FILTER: C_States["filter"] = {
  searchValue: "",
};

const fileType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const fileExtension = ".xlsx";

class QuotationListContainer extends React.Component<MergedProps, C_States> {
  constructor(props) {
    super(props);
    const quotationDetailId = this.props.match.params.quotationId;

    this.state = {
      filter: EMPTY_FILTER,
      statusFilterAll: true,
      statusFilter: {
        freight_forwarding: true,
        ecommerce_fulfillment: true
      },
      statusQuery: "",
      fetchedQuotation: INITIAL_FETCHING_PAGINATION_DATA,

      visibleQuotationId: quotationDetailId,
      visibleQuotationDetail: null,
      quotationStatus: {
        status: QuotationStatus.NEW
      }
    };
  }

  exportToXLSX = () => {
    QuotationService.filterQuotation()
      .then((res) => {
        if (res && res.data?.data) {

          // Transform data for excel
          let quotationData: QuotationExportExcelOutputModel[] = res.data.data;

          quotationData.forEach((item) => {
            delete item.id;
            delete item.freight_forwarding;
            delete item.ecommerce;
            item.createdAt = moment(item.createdAt).format("DD/MM/yyyy")
            item.service = item.service === QuotationOptionService.FREIGHTFORWARDING
              ? "Freight forwarding"
              : item.service === QuotationOptionService.ECOMMERCE
                ? "E-commerce fulfillment"
                : "";
          })

          const fileName = "Report_Quotaion";
          const ws = XLSX.utils.json_to_sheet(res.data?.data);
          const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
          const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
          const data = new Blob([excelBuffer], { type: fileType });
          FileSaver.saveAs(data, fileName + fileExtension);
        }
      })
  };

  handleChangeStatus = (event, quotationCode: string) => {
    this.setState({
      quotationStatus: {
        status: event.target.value
      }
    }, () => {
      QuotationService.updateQuotationStatus(quotationCode, this.state.quotationStatus)
        .then((res) => {
          if (res && (res.status === 200 || res.status === 201)) {
            this.props.actions.enqueueSnackbar({
              type: AppNotifications.SUCCESS,
              message: "Update status success",
            });
            loadCallback(this.reloadListingPage);
          } else {
            this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Update status failed" });
          }
        })
        .catch((err) => {
          this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Update status failed" });
        });
    })
  };


  onChangeQuotationStatus = (status: QuotationStatus) => {
    this.setState((prevState) => {
      return {
        quotationStatus: {
          ...prevState.quotationStatus,
          status,
        },
      };
    });
  };

  openQuotationDetailModal = (quotation: QuotationOutputModel, quotationId?: string) => {
    this.setState({
      visibleQuotationId: quotationId,
      visibleQuotationDetail: quotation
      // }, () => {
      //   if (quotationId) {
      //     this.props.history.push(QuotationUtil.buildQuotationDetailPath(quotationId));
      //   }
    });
  };

  closeQuotationDetailModal = (cb?: TCb) => {
    this.props.history.push(APP_ROUTES.QUOTATION.BASE);
    this.setState({ visibleQuotationId: undefined, visibleQuotationDetail: null }, () => {
      loadCallback(cb?.success);
    });
  };

  reloadListingPage = () => {
    this.onApplyFilter(false);
  }

  onApplyStatusFilter = () => {
    this.onApplyFilter(false);
  }

  onSearch = _.debounce((searchValue: string) => {
    this.setState(
      (prevState) => {
        return {
          filter: {
            ...prevState.filter,
            searchValue,
          },
        };
      },
      () => {
        this.onApplyFilter(false);
      }
    );
  }, 300);

  onDeleteQuotation = (quotationCode) => {
    QuotationService.deleteQuotation(quotationCode)
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.SUCCESS,
            message: "Delete quotation success",
          });
          loadCallback(this.reloadListingPage);
        } else {
          this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Delete quotation failed" });
        }
      })
      .catch((err) => {
        this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Delete quotation failed" });
      });
  };

  handleChangeCheckBoxAll = (event) => {
    this.setState({
      statusFilterAll: event.target.checked
    }, () => {
      this.setState({
        statusFilter: {
          freight_forwarding: this.state.statusFilterAll,
          ecommerce_fulfillment: this.state.statusFilterAll
        }
      })
      if (this.state.statusFilterAll === false) {
        this.setState({ statusQuery: "" })
      }
    })
  }

  handleChangeCheckBox = (event) => {
    this.setState({
      statusFilter: ({
        ...this.state.statusFilter,
        [event.target.name]: event.target.checked
      })
    }, () => {
      let statusQuery: string = "";
      for (const key in this.state.statusFilter) {
        if (this.state.statusFilter[key] === true) {
          statusQuery = key
        }
      }
      this.setState({ statusQuery })
    });
  };

  clearFilter = () => {
    this.setState({
      statusFilterAll: false,
      statusFilter: {
        freight_forwarding: false,
        ecommerce_fulfillment: false
      },
    })
  }

  onApplyFilter = (loadMore: boolean, cb?: TCb) => {
    if (this.state.fetchedQuotation.loading && loadMore) return;

    this.setState(
      (prevState) => {
        return {
          fetchedQuotation: {
            ...prevState.fetchedQuotation,
            data: loadMore ? prevState.fetchedQuotation.data : [],
            loading: true,
          },
        };
      },
      () => {
        const query: Parameters<typeof QuotationService.filterQuotation>[0] = {
          page: loadMore ? this.state.fetchedQuotation.page + 1 : 1,
          limit: this.state.fetchedQuotation.limit,
          searchValue: this.state.filter.searchValue || undefined,
          filterValue: this.state.statusFilterAll ? undefined : this.state.statusQuery
        };

        QuotationService.filterQuotation(query)
          .then((res) => {
            if (res && res.data?.data) {
              console.log("llulu", res.data.data);
              this.setState(
                (prevState) => {
                  let quotation: QuotationOutputModel[] = [...res.data.data];

                  if (loadMore) {
                    quotation.unshift(...prevState.fetchedQuotation.data);
                  }

                  return {
                    fetchedQuotation: {
                      ...res.data,
                      data: quotation,
                      loading: false,
                    },
                  };
                },
                () => {
                  loadCallback(cb?.success);
                }
              );
            } else {
              this.props.actions.enqueueSnackbar({
                type: AppNotifications.ERROR,
                message: "Load data failed",
              });
              this.setState({
                fetchedQuotation: INITIAL_FETCHING_PAGINATION_DATA,
              });
            }
          })
          .catch((err) => {
            this.props.actions.enqueueSnackbar({
              type: AppNotifications.ERROR,
              message: "Load data failed",
            });
            this.setState({
              fetchedQuotation: INITIAL_FETCHING_PAGINATION_DATA,
            });
          });
      }
    );
  };

  onLoadMore = () => {
    this.onApplyFilter(true);
  };

  componentDidMount() {
    this.onApplyFilter(false, {
      success: () => { },
    });
  }

  render() {
    return (
      <QuotationListPresenter
        {...this.props}
        {...this.state}
        onLoadMore={this.onLoadMore}
        onSearch={this.onSearch}
        onChangeQuotationStatus={this.onChangeQuotationStatus}
        handleChangeCheckBox={this.handleChangeCheckBox}
        handleChangeCheckBoxAll={this.handleChangeCheckBoxAll}
        clearFilter={this.clearFilter}
        reloadListingPage={this.reloadListingPage}
        onDeleteQuotation={this.onDeleteQuotation}
        onApplyStatusFilter={this.onApplyStatusFilter}
        openQuotationDetailModal={this.openQuotationDetailModal}
        closeQuotationDetailModal={this.closeQuotationDetailModal}
        handleChangeStatus={this.handleChangeStatus}
        exportToXLSX={this.exportToXLSX}
      />
    );
  }
}

export default withRouter<C_Props, any>(
  connect<MapStateToProps, MapDispatchToProps, C_Props, RootState>(
    (state: RootState) => ({}),
    (dispatch: Dispatch) => ({
      actions: bindActionCreators(Object.assign(NotificationActions), dispatch),
    })
  )(QuotationListContainer)
);
